<template>
  <div style="margin: 10px 15px; background-color: white">
    <div class="searchBox">
      <el-form
        :inline="true"
        class="demo-form-inline"
        label-position="top"
        size="mini"
        ref="searchForm"
        label-width="130px"
        :model="searchObj"
      >
        <el-form-item label="所在区县">
          <el-select v-model="searchObj.region" filterable clearable disabled>
            <el-option
              v-for="item in seatList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国民经济行业">
          <el-select
            v-model="searchObj.industry_type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in industryList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登记注册类型">
          <el-select
            v-model="searchObj.registerType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in registerList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间选择">
          <el-date-picker
            v-model="searchObj.date_range"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否规上">
          <el-select
            v-model="searchObj.aboveScale"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否上市">
          <el-select v-model="searchObj.listed" placeholder="请选择" clearable>
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否军工">
          <el-select
            v-model="searchObj.military"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业规模">
          <el-select
            v-model="searchObj.companySize"
            placeholder="请选择"
            clearable
          >
            <el-option label="大型" value="大型"></el-option>
            <el-option label="中型" value="中型"></el-option>
            <el-option label="小型" value="小型"></el-option>
            <el-option label="微型" value="微型"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业类别">
          <el-select
            v-model="searchObj.companyCategory"
            placeholder="请选择"
            clearable
          >
            <el-option label="50户重点" value="50户重点"></el-option>
            <el-option label="小巨人" value="小巨人"></el-option>
            <el-option label="专精特新" value="专精特新"></el-option>
            <el-option label="隐形冠军" value="隐形冠军"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业性质">
          <el-select
            v-model="searchObj.companyNature"
            placeholder="请选择"
            clearable
          >
            <el-option label="国有" value="国有"></el-option>
            <el-option label="民营" value="民营"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="“565”产业" clearable>
          <el-cascader
            v-model="searchObj.company565"
            :options="Company565List"
            :props="deftProps"
            placeholder="请选择"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否超10亿元">
          <el-select
            v-model="searchObj.oneBillion"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提质倍增">
          <el-select
            v-model="searchObj.multiplication"
            placeholder="请选择"
            clearable
          >
            <el-option label="市级" value="市级"></el-option>
            <el-option label="区县级" value="区县级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店小二服务">
          <el-select
            v-model="searchObj.xiaoerService"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="三大改造实施">
          <el-select
            v-model="searchObj.threeChanges"
            placeholder="请选择"
            clearable
          >
            <el-option label="智能化改造" value="智能化改造"></el-option>
            <el-option label="绿色化改造" value="绿色化改造"></el-option>
            <el-option label="技术改造" value="技术改造"></el-option>
            <el-option label="未实施" value="未实施"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="margin-top: 37px">
            <el-button
              type="primary"
              @click="onSearch"
              class="bg5584FF formBotton"
              >查询</el-button
            >
            <el-button type="info" @click="onReset" class="formBotton"
              >重置</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-row style="margin: 10px 15px">
      <el-col :span="24">
        <el-table
          v-loading="loading"
          size="mini"
          border
          :height="tableData.length > 0 ? 420 : 180"
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
          :row-class-name="tableRowClassName"
          :data="tableData"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column prop="qymc" label="企业名称"></el-table-column>
          <el-table-column
            prop="ljgycz"
            sortable
            :formatter="handelFix2"
            label="累计工业产值（万元）"
          ></el-table-column>
          <el-table-column
            prop="qntqgycz"
            sortable
            :formatter="handelFix2"
            label="去年同期工业产值（万元）"
          ></el-table-column>
          <el-table-column
            prop="ljgyczRate"
            sortable
            :formatter="handelFix1"
            label="工业产值累计同比增速(%)"
          ></el-table-column>
          <el-table-column
            prop="ljxssr"
            sortable
            :formatter="handelFix2"
            label="累计销售收入（万元）"
          ></el-table-column>
          <el-table-column
            prop="qntqxssr"
            sortable
            :formatter="handelFix2"
            label="去年同期销售收入（万元）"
          ></el-table-column>
          <el-table-column
            prop="ljxssrRate"
            sortable
            :formatter="handelFix1"
            label="销售收入累计同比增速(%)"
          ></el-table-column>
          <el-table-column
            prop="ljsxlr"
            sortable
            :formatter="handelFix2"
            label="累计实现利润（万元）"
          ></el-table-column>
          <el-table-column
            prop="qntqlr"
            sortable
            :formatter="handelFix2"
            label="去年同期利润（万元）"
          ></el-table-column>
          <el-table-column
            prop="ljsxlrRate"
            sortable
            :formatter="handelFix1"
            label="利润累计同比增速(%)"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[20, 30, 50, 100]"
        layout="sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { export2Excel } from "@/utils/utils";
export default {
  props: {
    dataTpyeDef: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    dataIndexDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showArea: false,
      loading: false,
      areaName: "",
      startTime: "",
      endTime: "",
      srcDataList: "",
      currentPage: 1,
      pageSize: 20,
      exportLabel: "<<点击此处可导出报表",
      total: 0,
      searchObj: {
        region: this.regionCodeDef,
        date_range: this.timesDef.split(",")[0] || this.getNowQuarter(),
        page: 1,
        pageSize: 20,
      },
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      dialogTableVisible: false,
      queryData: {
        code: this.regionCodeDef,
      },
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: this.dataTpyeDef, //时间类型
      dataIndex: this.dataIndexDef, //数据指标
      dataRange: this.dataRangeDef, //数据类型
      times: this.timesDef, //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: [],
        pre: [],
        profit: [],
      },
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
      } else {
        this.times = new Date().getFullYear() + "-12";
      }
      this.initData();
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    getAreaList() {
      // 区县列表
      this.$axios
        .get("/business//park/seat")
        .then((res) => {
          this.$store.commit("setAreaLsit", res.data);
        })
        .catch((res) => {
          console.log("区县列表获取失败", res);
        });
    },
    getSelectList() {
      //获取下拉列表
      // 园区列表
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.parkList = res.data;
      });
      // 国民经济行业列表
      this.$axios.get("/business/project/industry").then((res) => {
        this.industryList = res.data;
      });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
      //565列表
      this.$axios.get("/business/company/selectCompany565List").then((res) => {
        this.Company565List = res.data;
      });
    },
    initData() {
      const self = this;
      this.loading = true;
      this.$axios
        .post("/business/companyMonitor/queryByCompany", this.searchObj)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: [],
            pre: [],
            profit: [],
          };
          this.showArea = false;
          this.loading = false;
          this.srcTableData = res.data;
          this.total = res.total;
          this.showTableData();
        });
    },
    showTableData() {
      const self = this;
      this.showArea = false;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      };
      this.srcTableData.forEach((item) => {
        const temp = {
          qymc: item.qymc,
          date_range: item.date_range,
          ljgycz: item.ljgycz,
          qntqgycz: item.qntqgycz,
          ljgyczRate:
            item.qntqgycz > 0
              ? ((item.ljgycz - item.qntqgycz) / item.qntqgycz) * 100
              : "--",
          ljxssr: item.ljxssr,
          qntqxssr: item.qntqxssr,
          ljxssrRate:
            item.qntqxssr > 0
              ? ((item.ljxssr - item.qntqxssr) / item.qntqxssr) * 100
              : "--",
          ljsxlr: item.ljsxlr,
          qntqlr: item.qntqlr,
          ljsxlrRate:
            item.qntqlr > 0
              ? ((item.ljsxlr - item.qntqlr) / item.qntqlr) * 100
              : "--",
        };
        this.areaData.xAxis.push(item.region);
        if (this.dataIndex === "gyzjz") {
          // 工业增加值
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(temp.ljgycz);
          this.areaData.pre.data.push(temp.qntqgycz);
          this.areaData.profit.data.push(temp.ljgyczRate);
        } else if (this.dataIndex === "yysr") {
          // 营业收入
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(temp.ljxssr);
          this.areaData.pre.data.push(temp.qntqxssr);
          this.areaData.profit.data.push(temp.ljxssrRate);
        } else if (this.dataIndex === "lrze") {
          // 利润总额
          this.areaData.curr.name = "累计";
          this.areaData.pre.name = "上年同期";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(temp.ljsxlr);
          this.areaData.pre.data.push(temp.qntqlr);
          this.areaData.profit.data.push(temp.ljsxlrRate);
        }
        this.tableData.push(temp);
      });
      console.log("this.tableData:", this.tableData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getYearRange(value) {
      this.startTime = value[0] + "-01";
      this.endTime = value[1] + "-12";
      this.initData();
    },
    yearChange(value) {
      this.times = value + "-12";
      this.initData();
    },
    monthChange(value) {
      this.startTime = value[0].slice(0, 4) + "-01";
      this.endTime = value[1].slice(0, 4) + "-12";
      this.initData();
    },
    onSearch() {
      this.initData();
    },
    onReset() {
      (this.searchObj = {
        region: this.regionCodeDef,
        date_range: this.timesDef.split(",")[0],
        page: 1,
        pageSize: 20,
      }),
        this.initData();
    },
    handleSizeChange(val) {
      this.searchObj.pageSize = val;
      this.searchObj.page = 1;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      console.log(`当前页: ${val}`);
      this.searchObj.page = val;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      var results = "";
      if (month < 10) {
        results = year + "-0" + month;
      } else {
        results = year + "-" + month;
      }
      console.log("results:", results);
      return results;
    },
    exportData() {
      let column = [
        {
          title: "企业名称",
          key: "qymc",
        },
        {
          title: "累计工业产值（万元）",
          toFixed: 2,
          key: "ljgycz",
        },
        {
          title: "去年同期工业产值（万元）",
          toFixed: 2,
          key: "qntqgycz",
        },
        {
          title: "工业产值累计同比增速(%)",
          toFixed: 1,
          key: "ljgyczRate",
        },
        {
          title: "累计销售收入（万元）",
          toFixed: 2,
          key: "ljxssr",
        },
        {
          title: "去年同期销售收入（万元）",
          toFixed: 2,
          key: "qntqxssr",
        },
        {
          title: "销售收入累计同比增速(%)",
          toFixed: 1,
          key: "ljxssrRate",
        },
        {
          title: "累计实现利润（万元）",
          toFixed: 2,
          key: "ljsxlr",
        },
        {
          title: "累计实现利润（万元）",
          toFixed: 2,
          key: "qntqlr",
        },
        {
          title: "利润累计同比增速(%)",
          toFixed: 1,
          key: "ljsxlrRate",
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        let quarter = "";
        if (this.times.slice(5, 7) === "01") {
          quarter = "1";
        } else if (this.times.slice(5, 7) === "04") {
          quarter = "2";
        } else if (this.times.slice(5, 7) === "07") {
          quarter = "3";
        } else if (this.times.slice(5, 7) === "10") {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      export2Excel(column, this.tableData, this.title + "_企业_" + timeStr);
    },
  },
  created() {
    this.getAreaList();
    this.getSelectList();
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.topBtnBox {
  display: flex;
  justify-content: space-between;
  i.show {
    animation: showRotate 0.5s forwards;
  }
  i.close {
    animation: closeRotate 0.5s forwards;
  }
}
@keyframes showRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(180deg);
  }
}
@keyframes closeRotate {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0);
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 30px 0 20px;
}
.searchBox {
  overflow: hidden;
  height: 378px;
  background-color: rgba(173, 173, 173, 0.02);
  border-radius: 2px;
  // border: 1px solid rgba(114, 114, 114, 0.15);
  padding: 0 15px;
  .el-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    div:nth-last-child(1) {
      box-sizing: border-box;
    }
    .el-form-item {
      width: 24%;
    }
    .item {
      width: 37%;
      display: flex;
      .el-form-item.halfOne {
        width: 55%;
        display: flex;
      }
      .el-form-item.halfTwo {
        width: 45%;
        display: flex;
      }
    }
  }
}
.search-leave-active,
.search-enter-active {
  transition: all 0.8s ease;
}
.search-leave-active,
.search-enter {
  height: 0px !important;
}
.search-leave,
.search-enter-active {
  height: 420px;
}
.hr-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.2s;
}
.hr-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.hr-enter,
.hr-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.search {
  width: 40%;
  margin-bottom: 15px;
}
.pageBox {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>